module.exports = __webpack_public_path__ + "static/media/circumference_dog_english.f27c0bea.png";